// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__io4cH","content":"LoadingAlert_content__1FEwz"};